import { useState } from "react";
import { Zap } from "lucide-react";
import { playThunder, unlockAudio } from "../../lib/thunder";

export const shouldShowSplash = () => true;

const Strike = () => (
  <>
    <div className="hero-flash pointer-events-none absolute inset-0" aria-hidden="true" />
    <svg className="splash-bolt pointer-events-none absolute left-1/2 top-0 h-[55vh] -translate-x-1/2" viewBox="0 0 100 300" fill="none" aria-hidden="true">
      <path d="M60 0 L35 120 L58 120 L30 300 L75 105 L52 105 L80 0 Z" fill="#fff" />
    </svg>
  </>
);

export const Splash = ({ onReady }) => {
  const [phase, setPhase] = useState("idle");

  const enter = () => {
    if (phase !== "idle") return;
    unlockAudio();
    setPhase("strike");
    setTimeout(playThunder, 60);
    setTimeout(() => {
      setPhase("leaving");
      onReady();
      setTimeout(() => setPhase("gone"), 500);
    }, 1900);
  };

  if (phase === "gone") return null;
  const striking = phase !== "idle";
  return (
    <div className={`splash fixed inset-0 z-[100] grid place-items-center bg-[#05060A] ${phase === "leaving" ? "splash-out" : ""}`} style={{ "--spd": 0.8 }} data-testid="brand-splash">
      {striking && <Strike />}
      <div className="relative flex flex-col items-center px-6">
        <div className={`${striking ? "logo-flash" : "splash-idle"} w-40 sm:w-52`}>
          <div className="logo-glow" style={{ "--logo-mask": "url(/assets/logo-anim.png)" }}>
            <img src="/assets/logo-anim.png" alt="ASAP & Co. Custom Print Group" draggable="false" />
          </div>
        </div>
        {striking ? (
          <p className="flash-text mt-8 font-display text-xl font-black uppercase tracking-[0.3em] text-white sm:text-2xl" style={{ animationDelay: "calc(var(--spd) * 0.9s)" }}>Custom Print Group</p>
        ) : (
          <button onClick={enter} className="btn-red splash-cta mt-8 !px-9 !py-4 !text-xl" data-testid="splash-enter-button">
            <Zap className="h-5 w-5" /> Tap to Enter
          </button>
        )}
      </div>
    </div>
  );
};
